module.exports = __webpack_public_path__ + "static/media/KaporgBlueIcon.7c0766b2.svg";